import type { Cart } from '@iheartjane/data-access';

// Deep, so no reader can mutate the shared instance's nested arrays.
const deepFreeze = <T>(value: T): T => {
  if (value && typeof value === 'object') {
    Object.values(value).forEach(deepFreeze);
    Object.freeze(value);
  }
  return value;
};

/**
 * Stand-in for a null cart in the checkout context, so its readers need no null
 * checks. One shared instance keeps the reference stable across renders.
 * TODO(carts-v3): remove with the rest of `cartFacade/`.
 */
export const EMPTY_V3_CART: Cart = deepFreeze<Cart>({
  all_discounts_total: 0,
  amount: null,
  amounts_manager: '',
  app_mode_name: '',
  applied_specials: [],
  brand_discounts: [],
  brand_discounts_service_fee_total: 0,
  brand_discounts_total: 0,
  brand_discounts_total_with_fee: 0,
  brand_special_has_changed: false,
  brand_special_unavailable_reason: null,
  cart_discount_amount: 0,
  cart_discount_special_id: null,
  checked_out_at_with_store_timezone: null,
  created_at: null,
  crm_redemptions: [],
  delivery_fee_amount: 0,
  delivery_finished_at: null,
  delivery_started_at: null,
  discounted_product_total: 0,
  discounted_subtotal: 0,
  dismissed_message: null,
  employee: { name: null, phone: null },
  fee_tax_amount: 0,
  group_discounts_total: 0,
  group_special_id: null,
  group_special_title: null,
  id: 0,
  item_total: 0,
  jane_pay_service_fee_amount: 0,
  loyalty_points_stacking_enabled: false,
  max_specials_per_cart: null,
  max_specials_per_cart_hit: false,
  order_total: 0,
  pos_cart: { totals: null },
  product_counts_have_been_capped: false,
  product_discounts_total: 0,
  products: [],
  products_count: 0,
  promo_code: null,
  promotions_opt_out: false,
  quantity_adjusted_products: [],
  rating: null,
  removed_crm_redemptions: [],
  reservation_mode: 'pickup',
  rounding_amount: 0,
  sales_tax_amount: 0,
  sales_tax_rate: 0,
  service_fee_amount: 0,
  special_has_changed: false,
  status: '',
  store: { id: 0 },
  store_tax_amount: 0,
  suggested_specials: [],
  tax_included: false,
  tip_amount: 0,
  unavailable_products: [],
  uuid: '',
});
